import React, { useEffect, useState } from "react";
import AdminNavigation from "../AdminNavigation";
import "./style.css";
import { api_v2 } from "../../NewIndex.api";
import { addNotification as notify } from "reapop";
import connect from "react-redux/es/connect/connect";
import AdminConfirmationModal from "../adminConfirmationModal";
import DuplicateModal from "./DuplicateModal";
import { withRouter } from "react-router-dom";
import MessageModal from "./MessageModal";

const ManageStaticPage = (props) => {
  const [activeTab, setActiveTab] = useState("liveContent");
  const [liveList, setLiveList] = useState([]);
  const [draftList, setDraftList] = useState([]);

  const [liveSearch, setLiveSearch] = useState("");
  const [draftSearch, setDraftSearch] = useState("");
  const [filteredLive, setFilteredLive] = useState([]);
  const [filteredDraft, setFilteredDraft] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] = useState(false);
  const [duplicateId, setDuplicateId] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editObject, setEditObject] = useState({});
  const [isExistingTemplate, setIsExistingTemplate] = useState(false);
  const [parentTemplateName, setParentTemplateName] = useState("");
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [displayMessage, setDisplayMessage] = useState("");

  useEffect(() => {
    api_v2.fetchTemplateLive((res) => {
      setLiveList(res);
      setFilteredLive(res);
    });
    api_v2.fetchTemplateDraft((res) => {
      setFilteredDraft(res);
      setDraftList(res);
    });

    //query Params
    const searchParams = new URLSearchParams(props.location.search);
    const tabRequired = searchParams.get("tab");
    if (tabRequired) {
      setActiveTab(tabRequired);
    } else {
      setActiveTab("liveContent");
    }
  }, []);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  useEffect(() => {
    setFilteredLive(
      liveSearch
        ? liveList.filter((entry) =>
            entry.templateName.toLowerCase().includes(liveSearch.toLowerCase())
          )
        : liveList
    );
  }, [liveSearch, liveList]);

  useEffect(() => {
    setFilteredDraft(
      draftSearch
        ? draftList.filter((entry) =>
            entry.templateName.toLowerCase().includes(draftSearch.toLowerCase())
          )
        : draftList
    );
  }, [draftSearch, draftList]);

  const handleDelete = (id) => {
    if (id) {
      const queryParams = {
        id: id,
      };
      api_v2.deleteTemplate(queryParams, (res) => {
        if (res.status === 200 && res.ok) {
          showNotification("Success", "Draft deleted successfully", "success");
          setDraftList((prev) => prev.filter((entry) => entry.id !== id));
          setFilteredDraft((prev) => prev.filter((entry) => entry.id !== id));
          setOpenDeleteModal(false);
          setDeleteId(null);
        } else {
          showNotification("Error!", "Please try again later", "error");
        }
      });
    }
  };

  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };

  const handleLiveEdit = (object) => {
    if (object.id) {
      const queryParams = {
        liveVersionId: object.id,
      };
      api_v2.createContentDraft(queryParams, (res) => {
        if (res.status === 200 && res.ok) {
          showNotification("Success", "Draft created successfully", "success");
          setOpenEditModal(false);
          getDraftAndSearch(object);
        } else if (res.status === 409) {
          setOpenEditModal(false);
          setIsExistingTemplate(true);
        } else {
          showNotification("Error!", "Please try again later", "error");
        }
      });
    }
  };

  const handleExistingTemplate = (object) => {
    setIsExistingTemplate(false);
    getDraftAndSearch(object);
  };

  const getDraftAndSearch = (object) => {
    api_v2.fetchTemplateDraft((res) => {
      setFilteredDraft(res);
      setDraftList(res);
      setActiveTab("draftContent");
      setDraftSearch(object.name);
      setEditObject({});
    });
  };

  const handleDraft = (id) => {
    const draftContentId = id;
    const url = `/admin/create-static-page?draftContentId=${encodeURIComponent(
      draftContentId
    )}`;
    setTimeout(() => props.history.push(url), 2000);
  };

  const handlePreview = (id, type) => {
    const url = `/admin/content-preview-page?id=${encodeURIComponent(
      id
    )}&type=${encodeURIComponent(type)}`;
    setTimeout(() => props.history.push(url), 2000);
  };
  return (
    <div className="v2_container">
      <div className="row">
        {openDeleteModal && (
          <AdminConfirmationModal
            isModalOpen={openDeleteModal}
            toggleYes={() => handleDelete(deleteId)}
            toggleCancel={() => setOpenDeleteModal(false)}
            bodyContent={
              "Are you sure you want to delete? This action cannot be undone!!"
            }
          />
        )}
        {isDuplicateModalOpen && (
          <DuplicateModal
            isModalOpen={isDuplicateModalOpen}
            openMessageModal={() => setIsMessageModalOpen(true)}
            setMessage={setDisplayMessage}
            parentTemplateName={parentTemplateName}
            closeModal={() => {
              setDuplicateId(null);
              setIsDuplicateModalOpen(false);
              setParentTemplateName("");
            }}
            showNotification={showNotification}
            liveVersionId={duplicateId}
            updateLive={(res) => {
              setLiveList(res);
              setFilteredLive(res);
            }}
          />
        )}
        {openEditModal && (
          <AdminConfirmationModal
            isModalOpen={openEditModal}
            toggleYes={() => handleLiveEdit(editObject)}
            toggleCancel={() => setOpenEditModal(false)}
            bodyContent={
              "You will be redirected to Draft Tab. Click on Yes to continue. This action cannot be undone!!"
            }
          />
        )}
        {isExistingTemplate && (
          <AdminConfirmationModal
            isModalOpen={isExistingTemplate}
            toggleYes={() => handleExistingTemplate(editObject)}
            toggleCancel={() => setIsExistingTemplate(false)}
            bodyContent={
              "Draft already exists with the same template name!! If you want to edit the existing draft click on Yes"
            }
          />
        )}
        {isMessageModalOpen && (
          <MessageModal
            isModalOpen={isMessageModalOpen}
            closeModal={() => {
              setIsMessageModalOpen(false);
              setDisplayMessage("");
            }}
            message={displayMessage}
          />
        )}
        <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
        <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
          <div className="row">
            <div className="col-12 col-xl-12">
              <h3 className="mb-3 header-primary">Manage Static Pages</h3>
              <p>Hover over a field below to make changes</p>
            </div>
          </div>
          <div>
            <div
              className="row"
              style={{
                marginTop: "15px",
                marginLeft: "1px !important",
                marginBottom: "15px",
              }}
            >
              <div
                className={`col-4 col-xl-4 col-sm-6 tabLive ${
                  activeTab === "liveContent" ? "activeTab" : ""
                }`}
                onClick={() => handleTabClick("liveContent")}
              >
                Content Live Data
              </div>
              <div
                className={`col-4 col-xl-4 col-sm-6 tabLive ${
                  activeTab === "draftContent" ? "activeTab" : ""
                }`}
                onClick={() => handleTabClick("draftContent")}
              >
                Content Draft Data
              </div>
            </div>
            {activeTab === "liveContent" ? (
              <div>
                <div className="row">
                  <div className="col-12 col-xl-12">
                    <h4 className="mb-3 header-primary">Content Data (Live)</h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-7 search-col">
                    <div
                      className="input-group search-group"
                      style={{ marginBottom: "2rem" }}
                    >
                      <input
                        type="search"
                        placeholder="Search by template name"
                        value={liveSearch}
                        onChange={(e) => setLiveSearch(e.target.value)}
                        className="search-bar form-control"
                      />
                      {liveSearch && (
                        <button
                          className="reset-button"
                          aria-label="Clear Value"
                          onClick={() => {
                            setLiveSearch("");
                            setFilteredLive(liveList);
                          }}
                        >
                          <i className="fa fa-times" />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row" style={{ overflowX: "scroll" }}>
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th style={{ border: "1px solid #fff" }}></th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Template Name
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Template Description
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Created By
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Created On
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Edit
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Duplicate
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredLive.map((entry, index) => (
                        <tr key={index}>
                          <td
                            onClick={() =>
                              handlePreview(entry.templateName, "live")
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-eye-fill"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
                                style={{ color: "#071d49" }}
                              />
                              <path
                                d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
                                style={{ color: "#071d49" }}
                              />
                            </svg>
                          </td>
                          <td
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                            }}
                          >
                            {entry.templateName}
                          </td>
                          <td
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                            }}
                          >
                            {entry.templateDescription}
                          </td>
                          <td
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                            }}
                          >
                            {entry.createdBy || ""}
                          </td>
                          <td
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                            }}
                          >
                            {entry.createdOn || ""}
                          </td>
                          <td
                            className="duplicate-action-cell"
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                              color: "red",
                              textAlign: "center",
                            }}
                            onClick={() => {
                              setEditObject({
                                name: entry.templateName,
                                id: entry.id,
                              });
                              setOpenEditModal(true);
                            }}
                          >
                            Edit
                          </td>
                          <td
                            className="duplicate-action-cell"
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                              color: "red",
                              textAlign: "center",
                            }}
                            onClick={() => {
                              setDuplicateId(entry.id);
                              setIsDuplicateModalOpen(true);
                              setParentTemplateName(entry.templateName);
                            }}
                          >
                            Duplicate
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div>
                <div className="row">
                  <div className="col-12 col-xl-12">
                    <h4 className="mb-3 header-primary">
                      Content Data (Draft)
                    </h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-7 search-col">
                    <div
                      className="input-group search-group"
                      style={{ marginBottom: "2rem" }}
                    >
                      <input
                        type="search"
                        placeholder="Search by template name"
                        value={draftSearch}
                        onChange={(e) => setDraftSearch(e.target.value)}
                        className="search-bar form-control"
                      />
                      {draftSearch && (
                        <button
                          className="reset-button"
                          aria-label="Clear Value"
                          onClick={() => {
                            setDraftSearch("");
                            setFilteredDraft(draftList); // Reset to show all entries
                          }}
                        >
                          <i className="fa fa-times" />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row" style={{ overflowX: "scroll" }}>
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th style={{ border: "1px solid #fff" }}></th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Template Name
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Template Description
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Created By
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Created On
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            border: "1px solid #fff",
                          }}
                        >
                          Delete
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDraft.map((entry, index) => (
                        <tr key={index}>
                          <td
                            onClick={() => handlePreview(entry.id, "draft")}
                            style={{ cursor: "pointer" }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-eye-fill"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
                                style={{ color: "#071d49" }}
                              />
                              <path
                                d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
                                style={{ color: "#071d49" }}
                              />
                            </svg>
                          </td>
                          <td
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                            }}
                            className="duplicate-action-cell"
                            onClick={() => handleDraft(entry.id)}
                          >
                            {entry.templateName}
                          </td>
                          <td
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                            }}
                          >
                            {entry.templateDescription}
                          </td>
                          <td
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                            }}
                          >
                            {entry.createdBy || ""}
                          </td>
                          <td
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                            }}
                          >
                            {entry.createdOn || ""}
                          </td>
                          <td
                            className="delete-action-cell"
                            style={{
                              fontSize: "medium",
                              fontStyle: "inherit",
                              fontWeight: "bold",
                              border: "1px solid #fff",
                              color: "red",
                              textAlign: "center",
                            }}
                            onClick={() => {
                              setDeleteId(entry.id);
                              setOpenDeleteModal(true);
                            }}
                          >
                            Delete
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
});

export default withRouter(
  connect(mapStateToProps, { notify })(ManageStaticPage)
);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Content Management/ManageStaticPage.js